<template>
    <div>
        <b-container fluid class="px-0">
            <b-card id="card-principal" class="mb-0 pb-0">
                <template #header>
                    <div class="flex-grow-1">
                        <i class="fas fa-table"></i>
                        <strong>{{$lang.Menu.Items.PCI.PDRItemRating}}</strong>
                    </div>
                </template>
                <!--grid of reports-->
                <b-row>
                    <ag-grid-vue style="width: 100%; height:40vh" id="obras-grid"
                        class="ag-theme-alpine"
                        :rowMultiSelectWithClick="false"
                        rowSelection="single"
                        :getLocaleText="localeTextFunc"
                        :gridOptions="reportGridOptions"
                        :columnTypes="columnTypes"
                        :columnDefs="reportColumnDefs"
                        :defaultColDef="defaultColumnDef"
                        :rowData="reportRowData"
                        :suppressColumnVirtualisation=true
                        @gridReady="onGridReportReady"
                        >
                    </ag-grid-vue>
                </b-row>
                <!--tabs section-->
                <b-row>
                    <b-tabs id="tab" v-model="tabIndex" pills card>
                        <b-tab title="Obras">
                            <ag-grid-vue style="width: 100%; height:20vh" id="obras-grid"
                                class="ag-theme-alpine"
                                :rowMultiSelectWithClick="false"
                                rowSelection="single"
                                :getLocaleText="localeTextFunc"
                                :gridOptions="workGridOptions"
                                :columnTypes="columnTypes"
                                :columnDefs="workColumnDefs"
                                :defaultColDef="defaultColumnDef"
                                :rowData="workRowData"
                                :suppressColumnVirtualisation=true
                                @gridReady="onGridWorkReady"
                                >
                            </ag-grid-vue>
                        </b-tab>
                        <b-tab title="Relatório">
                            <div class="d-flex flex-column justify-content-start" style="width: 100%; height:20vh">

                            </div>
                        </b-tab>
                        <b-tab title="Gráficos">
                            <div class="d-flex flex-column justify-content-start" style="width: 100%; height:20vh">

                            </div>
                        </b-tab>
                    </b-tabs>
                </b-row>
            </b-card>
        </b-container>
    </div>
</template>

<script>
import ReportItem from './reportItem.js'
export default ReportItem
</script>

<style scoped>
    #tab {
        width: 100%;
        margin: 0px 5px 0px 5px;
    }
    .align-right {
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/reportItem/reportItem.vue